import {useCallback} from 'react'

import {CRITEO_FREESPEE_ITEM_ID} from './config'
import {getCriteoFreespeePixel} from './utils'
const useCriteoFreespeeTrack = () => {
  const _onDispatchTrack = () =>
    useCallback(async ({sessionId}) => {
      const pixelUrl = getCriteoFreespeePixel({sessionId})
      window.c_item_id = CRITEO_FREESPEE_ITEM_ID
      const freespeeCriteoPixel = document.createElement('img')
      freespeeCriteoPixel.setAttribute('src', pixelUrl)
      freespeeCriteoPixel.setAttribute('style', 'position:absolute;height:0;width:0;')
      document.head.appendChild(freespeeCriteoPixel)
    }, [])

  return {track: _onDispatchTrack()}
}

export default useCriteoFreespeeTrack
